const initialState = {
  authenticated: false,
  clinicUrl: "",
  sessionId: null
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "setAuth":
      return {
        ...state,
        authenticated: payload,
      };

      case "setClinicUrl":
        return {
          ...state,
          clinicUrl: payload,
        };

      case "setSessionId":
        return {
          ...state,
          sessionId: payload,
        };

    default:
      return state;
  }
};

export default reducer;
